import axios from "axios";
import { ADMIN_PORTAL_API_BASE_URL, ADMIN_PORTAL_AUTH_TOKEN } from "../utils/config";

export const getErrorLogs = async (payload) => {
    const url = `${ADMIN_PORTAL_API_BASE_URL}/get_app_error`

    const config = {
        method: "POST",
        url,
        data: payload,
        headers: {
            Authorization: `Bearer ${ADMIN_PORTAL_AUTH_TOKEN}`,
        },
    };

    try {
        const response = await axios(config);
        // let tempData =
        // {
        //     "total_query_count": 12,
        //     "total_unique_user": 23,
        //     "total_daily_new_user": 34,
        //     "total_cta_clicks": 34,
        //     'abc.xlsx': 'https://abcd.xlsx',
        //     'abc2.xlsx': 'https://abc2.xlsx',
        //     'abc3.xlsx': 'https://abc3.xlsx',
        //     'abc4.xlsx': 'https://abc4.xlsx',
        //     'abc5.xlsx': 'https://abc5.xlsx'
        // }
        // console.log(tempData, "tempData GETLOGS");
        // response.data.payload = payload
        // return tempData;
        return response.data;
    } catch (error) {
        console.error("Error fetching analytics data:", error);
        throw error.response?.data || error;
    }
};
